// Text Component API :
//
// <Text id='foobar' placeholders={{foo: bar, baz: 'success'}} />
//
// de.js:
// {
//   foobar 'The %foo is a huge $success',
//   success: 'failure'
// }
//
// % denotes simple replacement
// $ denotes language replacement
//
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import replace from '../utilities/replace';

import de from '../config/languages/de';
import es from '../config/languages/es';
import en from '../config/languages/en';
import fr from '../config/languages/fr';
import it from '../config/languages/it';

export const getDict = language => {
  if (language === 'de') { return getText(de); }
  if (language === 'en') { return getText(en); }
  if (language === 'es') { return getText(es); }
  if (language === 'it') { return getText(it); }
  if (language === 'fr') { return getText(fr); }

  return getText({});
}

const getText = dict => id => {
  if (dict[id]) {
    return dict[id];
  } else {
    return id;
  }
}

const mapStateToProps = ({config}) => ({
  language: config.language
});

const parseText = (text, placeholders, dict) => {
  let parsedText = text;

  if (placeholders) {
    // replace value placeholders
    parsedText = replace(parsedText, placeholders, '%');
    // replace language placeholders
    parsedText = replace(parsedText, placeholders, '$', (id) => (
      dict(id)
    ));
  }

  return parsedText;
}

export let translate = () => ('translate not set');

export let Text = (props) => {
  const {language, id, placeholders} = props;
  const dict = getDict(language);
  let text = dict(id);

  if (typeof text === 'string') {
    return <span className={props.className} lang={language}>
      {parseText(text, placeholders, dict)}
    </span>;
  }

  if (typeof text === 'object' && text.__html) {
    text.__html = parseText(text.__html, placeholders, dict);
    return <span className={props.className} lang={language} dangerouslySetInnerHTML={text}></span>;
  }
}

// FIXME: there is probably a nicer way for this
export let Option = (props) => {
  const {language, id, value} = props;
  const dict = getDict(language);

  return <option className={language} value={value}>
    {dict(id)}
  </option>;
}

export let TranslatedInput = props => {
  const {language, placeholderId} = props;
  const dict = getDict(language);

  return <input
    placeholder={dict(placeholderId)}
    id={props.id}
    className={props.className}
    ref={props.setRef}
    type={props.type}
    value={props.value}
    onChange={props.onChange}
  />;
}

export let TranslatedLink = props => {
  const {language, text, href, webtrekk} = props;
  const dict = getDict(language);

  if (webtrekk) {
    return (
        <a href={dict(`${href}`)}
            className={props.className}
            target={props.target ? props.target : null}
            onClick={() => {
                window.wts.push(['send', 'click', {linkId: 'so funktionierts'}]);
            }}>
            {dict(text)}
        </a>
    );
  }

  return <a href={dict(`${href}`)} className={props.className} target={props.target ? props.target : null}>{dict(text)}</a>;
}

Text = connect(mapStateToProps)(Text)
Option = connect(mapStateToProps)(Option)
TranslatedInput = connect(mapStateToProps)(TranslatedInput)
TranslatedLink = connect(mapStateToProps)(TranslatedLink)

// Option.PropTypes = {
//   value: PropTypes.string.isRequired
// };

export default Text;
